import { getUsuarioCompact } from '../../config/auth';
import { Collection, WhereField } from '../../shared/constants';
import { getAllDocsByQueries, updateDoc } from './collectionBaseWorker';
import { getParkById } from './parkWorker';
import { where } from "firebase/firestore";

export const addUserLog = async ({ estacionamentoId, module, message }) => {
    const user = getUsuarioCompact()
    const park = await getParkById({ id: estacionamentoId })
    const data = {
        estacionamentoId: park.id,
        estacionamentoNome: park.nome,
        clienteId: park.clienteId,
        revendaId: park.revendaId,
        createdBy: {
            id: user.id,
            name: user.nome,
            email: user.email
        },
        module: module,
        message: message,
    }
    await updateDoc({ collection: Collection.USER_LOGS, id: data.id, data: data })
}

export const getAllLogsByUserId = async ({ usuarioId }) => {
    return await getAllDocsByQueries({
        collection: Collection.USER_LOGS,
        queries: [
            where(WhereField.CREATED_BY__ID, "==", usuarioId)
        ]
    })
}